import React from 'react';
import { motion } from 'framer-motion';
const chapters = [{
  num: '01',
  title: 'La Anatomía del Quiebre',
  desc: 'Entender exactamente por qué Dios permitió que esto pasara y dejar de verte como víctima.'
}, {
  num: '02',
  title: 'El Protocolo de la Vasija',
  desc: 'Cómo identificar en qué fase del proceso de Dios estás y qué hacer en cada una.'
}, {
  num: '03',
  title: 'El Mapa del Desierto',
  desc: 'Navegar el silencio de Dios sin perder la fe ni la cordura.'
}, {
  num: '04',
  title: 'Cirugía de Identidad',
  desc: 'Descubrir quién eres cuando le quitas todo lo que perdiste y construir desde ahí.'
}, {
  num: '05',
  title: 'Plan de Oraciones de Guerra',
  desc: 'Oraciones específicas para el colapso financiero, la traición, el duelo y el ataque de ansiedad.'
}, {
  num: '06',
  title: 'Tu Plan de 21 Días',
  desc: 'Acciones de fe diarias, simples y poderosas para salir del desierto con autoridad.'
}];
export function ProductContents() {
  return <section className="py-12 px-6" style={{
    backgroundColor: 'var(--bg-deep)'
  }} data-id="element-260">
      <div className="max-w-[800px] mx-auto" data-id="element-261">
        <div className="text-center mb-10" data-id="element-262">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block mb-5 relative" data-id="element-263">
            <img src="https://cdn.magicpatterns.com/uploads/1L9eAkStwSG5sdVN9P27cF/cover_1.png" alt="¿Por Qué a Mí, Dios?" className="w-40 rounded-lg shadow-[0_0_30px_rgba(139,105,20,0.2)] border border-[var(--accent)]/20" data-id="element-264" />
          </motion.div>
          <p className="text-[var(--accent)] uppercase tracking-widest text-xs font-bold mb-2" data-id="element-265">
            El Manual
          </p>
          <h2 className="text-2xl md:text-3xl font-serif text-[var(--text-heading)] mb-3" data-id="element-266">
            "¿Por Qué a Mí, Dios?"
          </h2>
          <p className="text-[var(--text-muted)] uppercase tracking-widest text-sm mb-4" data-id="element-267">
            Elegido en el Dolor: El Manual de 21 Días
          </p>
          <p className="text-lg text-[var(--text-primary)] max-w-2xl mx-auto leading-relaxed" data-id="element-268">
            Este no es un libro de motivación barata. No te va a decir "piensa
            positivo".{' '}
            <strong className="text-[var(--text-heading)]" data-id="element-269">
              Este es un mapa táctico para personas en crisis real.
            </strong>
          </p>
        </div>

        {/* Chapter List */}
        <div className="bg-[var(--bg-card)] rounded-xl border border-[var(--border-subtle)] overflow-hidden" data-id="element-270">
          <div className="px-6 py-4 bg-[var(--bg-elevated)] border-b border-[var(--border-subtle)]" data-id="element-271">
            <h3 className="text-center font-serif text-[var(--text-heading)] text-lg" data-id="element-272">
              Lo que encontrarás dentro
            </h3>
          </div>

          <div className="divide-y divide-[var(--border-subtle)]" data-id="element-273">
            {chapters.map((chapter, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.07
          }} className="p-5 flex gap-4 items-start hover:bg-[var(--bg-surface)] transition-colors" data-id="element-274">
                <span className="text-[var(--accent)] font-bold font-mono text-lg opacity-60 pt-0.5" data-id="element-275">
                  {chapter.num}
                </span>
                <div data-id="element-276">
                  <h4 className="font-bold text-[var(--text-heading)] text-base mb-1" data-id="element-277">
                    {chapter.title}
                  </h4>
                  <p className="text-[var(--text-muted)] text-sm leading-relaxed" data-id="element-278">
                    {chapter.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}